import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

/**
 * Labelled form control that renders the backend's per-field errors.
 *
 * `error` accepts either a string or the array DRF returns.
 * `children` is a render prop: (props) => <Input {...props} />
 */
export function Field({ label, name, error, children, hint, className }) {
  const message = Array.isArray(error) ? error[0] : error;
  const describedBy = [message ? `${name}-error` : null, hint ? `${name}-hint` : null]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      {label ? (
        <Label htmlFor={name} className={message ? "text-destructive" : undefined}>
          {label}
        </Label>
      ) : null}
      {children({
        id: name,
        name,
        "aria-invalid": Boolean(message) || undefined,
        "aria-describedby": describedBy || undefined,
      })}
      {hint ? (
        <p className="text-xs text-muted-foreground" id={`${name}-hint`}>
          {hint}
        </p>
      ) : null}
      {message ? (
        <p className="text-xs text-destructive" id={`${name}-error`} role="alert">
          {message}
        </p>
      ) : null}
    </div>
  );
}
